const LANGUAGE_ALIASES = {
  "spanish": 'es-MX',
  "english": 'en-US',
  "chinese": 'zh-CN',
  "es-CO": 'es-MX',
};

const resolveLanguageKey = (lang) => LANGUAGE_ALIASES[lang] || lang;

export default resolveLanguageKey;
